import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Form } from 'react-final-form';
// api + models
import api from '@/api';
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { makeSelectEventById } from '@/models/event';
// styles
import styles from './styles.module.scss';
// types
import { IContentTextColorTypes } from '@/types';
import Button from '@/components/ui/buttons/Button';
import FormSection from '@/components/forms/FormSection';
import Text, { ITextSizes, ITextStyles } from '@/components/ui/content/Text';
// utils
import { setPrimaryColor } from '@/utils/cssVars';

import { FORM_FIELDS } from './config';

const LoginWithTicketCode = ({
  buttonStyle,
  isSponsorLandingPage,
  isSpeakerPage,
}) => {
  const dispatch = useDispatch();
  const { eventId } = useParams<{ eventId: string }>();
  const event = useMemoizedSelector(makeSelectEventById, eventId);

  const [errorMessage, setErrorMessage] = useState();
  const { backgroundColor, color } = buttonStyle;

  useEffect(() => {
    const { primaryColor, secondaryColor } = event;
    setPrimaryColor(primaryColor, secondaryColor);
  }, [event]);

  const handleFormSubmit = _data => {
    const { lastName, ticketCode } = _data;
    const ticketCodeLoginPayload = {
      eventId,
      lastName,
      ticketCode,
      isAttendeeLogin: !isSpeakerPage,
    };
    api.account
      .loginWithTicketCode(ticketCodeLoginPayload)
      .then(({ data }) => {
        setErrorMessage(undefined);
        dispatch({ type: 'account/setAccount' });
        dispatch({ type: 'account/setUserData', payload: { data } });
      })
      .catch(err => {
        if (err?.response?.data?.description) {
          setErrorMessage(err?.response?.data?.description);
        } else {
          setErrorMessage(err?.response?.data);
        }
      });
  };

  return (
    <Form
      onSubmit={handleFormSubmit}
      render={({ handleSubmit, submitting }) => (
        <div className={styles.emailWrapper}>
          <FormSection
            formData={FORM_FIELDS}
            isSponsorLandingPage={isSponsorLandingPage}
            styleClass="formSectionColumnContainer"
          />
          {errorMessage && (
            <div className={styles.errorMessage}>
              <Text
                text={errorMessage}
                textColor={IContentTextColorTypes.DANGER}
                textSize={ITextSizes.XSMALL}
                textStyle={ITextStyles.SEMI_BOLDED}
              />
            </div>
          )}
          <Button
            label="Login"
            type="button"
            className={styles.submitButton}
            onClick={handleSubmit}
            disabled={submitting}
            style={{ backgroundColor: backgroundColor, color: color }}
          />
        </div>
      )}
    />
  );
};
export default LoginWithTicketCode;
